import React from "react";
import AddIcon from "../UIComponents/AddIcon";
import { connect } from "react-redux";
import { withRouter } from "react-router-dom";
import NotesManagementCard from "./NotesManagementCard";
import { event } from "jquery";
import { Multiselect } from "multiselect-react-dropdown";
import { getNotesList, deleteNote } from "../Actions/ShipNotesAPI";
import DatePicker from "react-datepicker";
import Moment from "moment";
import { confirmAlert } from "react-confirm-alert";
import { withTranslation } from "react-i18next";
import { toast } from "react-toastify";
import $ from "jquery";
let currentuser = JSON.parse(localStorage.getItem("currentUser"));


class NotesMngListScreen extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      searchData: {
        ShipId: 0,
        Title: "",
        NoteId: 0,
        Remark: "",
        Date: "",
        sortby: "desc",
        sortorder: "date",
        PageNumber: 1,
        PageSize: 10,
      },
      SelectedDate: "",
      DatePickerIsOpen: false,
    };
    this.SearchNotes = this.SearchNotes.bind(this);
    this.handleInputChange = this.handleInputChange.bind(this);
    this.ClearInput = this.ClearInput.bind(this);
    this.openDatePicker = this.openDatePicker.bind(this);
    this.handleInputDateChange = this.handleInputDateChange.bind(this);
    this.handleBlur = this.handleBlur.bind(this);
    this.EditNotes = this.EditNotes.bind(this);
    this.DeleteNotes = this.DeleteNotes.bind(this);
  }

  componentDidMount() {
    const { dispatch , t} = this.props;
    this.state.searchData["ShipId"] = this.props.match.params.shipid;
    this.setState({});
    dispatch(getNotesList(this.state.searchData));
    dispatch({ type: "SubBannerTitle", data: "SHIP REPORTS" });
    let _this = this;
    this.keyPressHandler = function (event) {
      var keycode = event.keyCode || event.which;
      
        if (keycode === 13) {
          if (_this.verifySearchItems()
          ) {
          _this.SearchNotes(1);
        }
        else{
          toast.success(t('Toast.Success'), {
            position: "top-right",
            autoClose: 2000,
            hideProgressBar: true,
            closeOnClick: true,
            pauseOnHover: true,
            draggable: true,
            progress: undefined,
          });
        }
      }
    }

    $(document).keypress(this.keyPressHandler);
  }

  componentWillUnmount() {

    $(document).off("keypress", this.keyPressHandler);
  }

  verifySearchItems = () => {
    let flag = true;
    if (this.state.searchData.Date == "" && this.state.searchData.Title == "" && this.state.searchData.sortorder=="") {
      flag = false;
    }
    return flag;
  }

  SearchNotes(pgno) {
    const { dispatch , t } = this.props;
    if (this.verifySearchItems()) {
 
    this.state.searchData["ShipId"] = this.props.match.params.shipid;
    this.state.searchData.PageNumber = pgno;
    this.setState({});
    dispatch(getNotesList(this.state.searchData));
    }
    else {
      toast.success(t('Toast.Success'), {
        position: "top-right",
        autoClose: 2000,
        hideProgressBar: true,
        closeOnClick: true,
        pauseOnHover: true,
        draggable: true,
        progress: undefined,
      });
    }
  }

  ClearInput() {
    const clearInput = {
      ShipId: 0,
      Title: "",
      NoteId: 0,
      Remark: "",
      Date: "",
      sortby: "desc",
      sortorder: "date",
      PageNumber: 1,
      PageSize: 10,
    };
    this.state.searchData = clearInput;
    this.state.searchData["ShipId"] = this.props.match.params.shipid;
    this.setState({});
    this.props.dispatch(getNotesList(this.state.searchData));
  }

  EditNotes(item) {
    const { dispatch, history } = this.props;
    dispatch({ type: "ShowNoteSidePan", data: true });
    dispatch({ type: "NoteDetails", data: item });
    history.push(`/Home/${this.props.match.params.shipid}/EditNote/${item.noteID}`);
    window.scrollTo(0, 0);
  }

  DeleteNotes(item) {
    const createdBy=currentuser.name;
    confirmAlert({
      message: 'Are you sure want to delete?',
      buttons: [
        {
          label: 'Yes',
          onClick: () => {
            const { dispatch } = this.props;
            dispatch(deleteNote(item.noteID, this.props.match.params.shipid,createdBy));
          }
        },
        {
          label: 'No',
          onClick: () => { }
        }
      ]
    });
  }

  NewitemNav() {
    this.props.dispatch({ type: "SHIP REPORTS", data: false });
    this.props.history.push(`/Home/${this.props.match.params.shipid}/AddNote`);
  }

  handleInputChange(e) {
    let nodeName = e.target.name;
    this.state.searchData[nodeName] = e.target.value;
    this.setState({});
  }

  handleInputDateChange(date) {
    this.state.searchData.Date = Moment(
      new Date(Date.parse(date))
    ).format("YYYY-MM-DD");
    this.setState({
      SelectedDate: date,
      DatePickerIsOpen: false,
    });
  }

  openDatePicker() {
    this.setState({
      DatePickerIsOpen: !this.state.DatePickerIsOpen,
    });
  }

  handleBlur() {
    this.setState({
      DatePickerIsOpen: false,
    });
  }
  hideSidePanel() {
      this.props.history.goBack(); 
}


  render() {
    const {
      ShipNoteList,
      ShowNoteSidePan,
      t
    } = this.props;
    console.log(this.props.t('DashboardShipReports.ShipReports'));
    
    return (
      <div className="full-height">
        <div className="pt-3">
          <div className="row">
          <button
              className="btn btn-primary text-uppercase txtside-btn txtht-btn blue m-2 ml-3"
              onClick={() => this.hideSidePanel()}
            >
              &larr; {t("CommonText.Back")}
            </button>
            <div className="col-lg-12">
              <div className="row">
                <div className="col-lg-12">
                  <div className="panel-box">
                    <div
                      className="card MM-card-header mb-0"
                      style={{ backgroundColor: "white" }}
                    >
                      <div
                        className="card-body flex"
                        style={{
                          padding: "0rem",
                          backgroundColor: "#1a3464",
                          color: "white",
                        }}
                      >
                        <h5
                          className="card-title ml-2 mt-2"
                          style={{ color: "092a51" }}
                        >
                       {t('DashboardShipReports.ShipReports')}
                        </h5>
                        <div
                          className="m-1 flex"
                          onClick={() => this.NewitemNav()}
                        >
                          <span className="mt-1 mdlabel">{t("ShipManagementContent.Add")}</span>
                          <AddIcon />
                        </div>
                      </div>
                    </div>
                    <div className="search-filter-box">
                      <div className="row">
                        <div
                          className={ShowNoteSidePan ? "col-lg-4 " : "col-lg-4 "}
                        >
                          <label className="form-label">{t("DashboardShipReports.Title")}</label>
                          <br></br>
                          <input
                            className="form-control"
                            type="text"
                            name="Title"
                            value={this.state.searchData.Title}
                            placeholder={t("DashboardShipReports.Title")}
                            onChange={(e) => this.handleInputChange(e)}
                          ></input>
                        </div>
                        <div
                          className={ShowNoteSidePan ? "col-lg-4 " : "col-lg-4 "}
                        >
                          <label className="form-label">{t("DashboardShipReports.Date")}</label>
                          <div
                            className="input-group add-on date datepicker"
                            data-date-format="yyyy-mm-dd"
                          >
                            <input
                              type="text"
                              value={this.state.searchData.Date}
                              className="form-control date-picker"
                              placeholder={t("DashboardShipReports.Date")}
                              name="fromDate"
                            ></input>
                            <DatePicker
                              selected={this.state.SelectedDate}
                              onChange={this.handleInputDateChange}
                              open={this.state.DatePickerIsOpen}
                              onClickOutside={this.handleBlur}
                              showMonthDropdown
                              showYearDropdown
                              dropdownMode="select"
                              className="form-control date-picker w-5 hide-date"
                            />
                            <div
                              className="input-group-btn calendar-icon"
                              onClick={this.openDatePicker}
                            >
                              <button className="btn btn-default">
                                <i className="fa fa-calendar mt-1"></i>
                              </button>
                            </div>
                          </div>
                        </div>
                        <div className={ShowNoteSidePan ? "col-lg-4 " : "col-lg-4 "}>
                          <label className="form-label" >{t("DashboardShipReports.SortBy")}</label><br></br>
                          <div className="row">
                            <div className={ShowNoteSidePan ? "col-lg-5 " : "col-lg-6 "}>
                              <select className="form-control" name="sortorder" value={this.state.searchData.sortorder} onChange={(e) => this.handleInputChange(e)}>
                                <option value="title">{t("DashboardShipReports.Title")}</option>
                                <option value="date" >{t("DashboardShipReports.Date")}</option>
                              </select>
                            </div>
                            <div className={ShowNoteSidePan ? "col-sm-3 mt-2" : "col-sm-3 mt-2"}>
                              <input type="radio" name="sortby" checked={this.state.searchData.sortby === 'asc'} value="asc" onChange={(e) => this.handleInputChange(e)}>
                              </input><span className="ml-1">{t("DashboardShipReports.Ascending")}</span>
                            </div>
                            <div className={ShowNoteSidePan ? "col-sm-4 mt-2" : "col-sm-3 mt-2"}>
                              <input type="radio" name="sortby" checked={this.state.searchData.sortby === 'desc'} value="desc" onChange={(e) => this.handleInputChange(e)}>
                              </input><span className="ml-1">{t("DashboardShipReports.Descending")}</span>
                            </div>
                          </div>
                        </div>
                        <div
                          className={
                            ShowNoteSidePan
                              ? "col-lg-12 m-auto pt-3 pb-2"
                              : "col-lg-12"
                          }
                        >
                          <div
                            className={
                              ShowNoteSidePan
                                ? "search-btn-col"
                                : "pt-4 search-btn-col"
                            }
                            style={{ textAlign: "end" }}
                          >
                            <button
                              className="btn btn-primary text-uppercase txtside-btn txtht-btn blue"
                              type="submit"
                              onClick={() => this.SearchNotes(1)}
                            >
                              {t("content.Search")}
                            </button>
                            <button
                              className="btn btn-light text-uppercase txtside-btn txtht-btn ml-3"
                              type="button"
                              onClick={() => this.ClearInput()}
                            >
                              {" "}
                              {t("content.Clear")}{" "}
                            </button>
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
              {ShipNoteList ? (
                <NotesManagementCard
                  arraylist={ShipNoteList?.data}
                  pageSize={ShipNoteList?.pagination?.pageSize}
                  totalRecords={
                    ShipNoteList?.pagination?.totalcount
                      ? ShipNoteList?.pagination?.totalcount
                      : 0
                  }
                  setUpdatedState={(value) => this.SearchNotes(value)}
                  EditNotes={(item) => this.EditNotes(item)}
                  DeleteNotes={(item) => this.DeleteNotes(item)}
                />
              ) : null}
            </div>
          </div>
        </div>
      </div>
    );
  }

}
function mapDispatchToProps(dispatch) {
  return {
    dispatch,
  };
}
function mapStateToProps(state) {
  return {
    ShipNoteList: state.ShipNotesReducer.ShipNoteList || {},
    ShowNoteSidePan: state.ShipNotesReducer.ShowNoteSidePan,
  };
}
// export default withRouter(
//   connect(mapStateToProps, mapDispatchToProps)(NotesMngListScreen)
// );

export default withTranslation()(withRouter(connect(mapStateToProps, mapDispatchToProps)(NotesMngListScreen)));